import http from '~/services/http/httpInstance'
const enumsUrl = "enums/";

export function httpGetEnums() {
  return http(enumsUrl).then(data => {
    return Promise.resolve(data);
  });
}
